export default __webpack_public_path__ + "static/media/errorImage.e4beba8e.svg";